import Spinner from '@/components/Spinner';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select';
import useEmployeesAll from '@/hooks/employee/useEmployeesAll';

interface CollectorDropDownProps {
  value: string;
  collector: Employee | undefined;
  onValueChange: (value: string) => void;
  isFilter?: boolean;
}

const CollectorDropDown = ({
  value,
  onValueChange,
  collector,
  isFilter = false,
}: CollectorDropDownProps) => {
  const { employees, loading } = useEmployeesAll();

  return (
    <Select onValueChange={onValueChange} defaultValue={value}>
      <SelectTrigger
        className={` ${
          isFilter
            ? 'md:border-none  bg-transparent'
            : 'h-[44px]  border border-[#C9C9C9] bg-white'
        }  font-normal flex justify-between w-full rounded-[5px]  px-3 py-1 text-sm  transition-colors placeholder:text-muted-foreground/50   disabled:cursor-not-allowed disabled:opacity-50 `}
      >
        {value ? (
          <span
            className={` ${isFilter ? 'text-[#979797] font-medium mr-2' : ''} `}
          >
            {value}
          </span>
        ) : (
          <span
            className={` ${
              isFilter ? 'text-[#979797] font-medium mr-2' : 'text-[#C9C9C9]'
            } `}
          >
            Collector
          </span>
        )}
      </SelectTrigger>
      <SelectContent>
        {loading ? (
          <SelectItem value='loading'>
            <Spinner />
          </SelectItem>
        ) : (
          <>
            {employees.length === 0 ? (
              <SelectItem value='No wilayas found'>
                No collector found
              </SelectItem>
            ) : (
              <>
                <SelectItem value='all'>All</SelectItem>
                {employees.map(
                  (item, index) =>
                    item.role === 'collector' && (
                      <SelectItem key={item.id} value={JSON.stringify(item)}>
                        {item.fullname}
                      </SelectItem>
                    )
                )}
              </>
            )}
          </>
        )}
      </SelectContent>
    </Select>
  );
};

export default CollectorDropDown;
